import { render, staticRenderFns } from "./exhibitor.vue?vue&type=template&id=2e19e063&scoped=true"
import script from "./exhibitor.vue?vue&type=script&lang=js"
export * from "./exhibitor.vue?vue&type=script&lang=js"
import style0 from "./exhibitor.vue?vue&type=style&index=0&id=2e19e063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19e063",
  null
  
)

export default component.exports